<template>
  <v-data-table
    :headers="headers"
    :items="providerAssignments"
    item-key="assignmentId"
    :key="providerAssignments.length"
    hide-default-footer
    :items-per-page="-1"
    dense
    ><template v-slot:[`top`]="{}">
      <v-subheader>Provider Assignments</v-subheader></template
    >
    <template v-slot:[`item.actions`]="{ item }">
      <div class="d-flex flex-nowrap">
        <provider-assignment-form
          v-if="canEdit"
          :assignment="item"
          :servicePlanId="servicePlanId"
        ></provider-assignment-form>
        <delete-modal
          v-if="canDelete(item)"
          title="Are you sure you want to REMOVE this service plan?"
          message="Note: This action cannot be undone."
          @save="deleteProviderAssignment($event, item)"
        ></delete-modal>
        <import-action-modal
          v-if="isAdmin && !viewOnly && !servicePlan.isSeitOrPend"
          :assignment="item"
        ></import-action-modal>
      </div>
    </template>
  </v-data-table>
</template>

<script>
import ProviderAssignmentForm from "./provider-assignment-form";
import DeleteModal from "../../Shared/delete-modal";
import ImportActionModal from "./import-action-modal.vue";

export default {
  components: { ProviderAssignmentForm, DeleteModal, ImportActionModal },
  props: ["servicePlanId", "viewOnly"],
  data() {
    return {
      dialog: false,
      headers: [
        { text: "Semester", value: "semester" },
        { text: "Provider", value: "providerName" },
        { text: "Mandate", value: "mandate" },
        { text: "Approval Start Date", value: "formattedApprovalStartDate" },
        { text: "Appoval End Date", value: "formattedApprovalEndDate" },
        { text: "Start Date", value: "formattedStartDate" },
        { text: "End Date", value: "formattedEndDate" },
        { text: "Actions", value: "actions", sortable: false },
      ],
    };
  },
  computed: {
    isAdmin() {
      return this.$store.getters["securityModule/isAdmin"];
    },
    plan() {
      return this.$store.state.plansModule.plans.find((item) =>
        item.servicePlans.find(
          (item) => item.servicePlanId == this.servicePlanId
        )
      );
    },
    servicePlan() {
      return this.plan.servicePlans.find(
        (item) => item.servicePlanId == this.servicePlanId
      );
    },
    providerAssignments() {
      return (
        this.servicePlan.assignments.slice().sort((a, b) => {
          const dateA = a.approvalStartDate;
          const dateB = b.approvalStartDate;

          if (dateA === null && dateB === null) return 0;
          if (dateA === null) return -1;
          if (dateB === null) return 1;

          return new Date(dateB) - new Date(dateA);
        }) ?? []
      );
    },
    canEdit() {
      return !this.viewOnly && this.servicePlan.isSeitOrPend;
    },
  },
  methods: {
    canDelete(assignment) {
      return (
        this.canEdit &&
        (this.$store.getters["securityModule/isEIAdmin"] ||
          this.$store.getters["securityModule/isSEITAdmin"]) &&
        !Boolean(assignment.startDate)
      );
    },
    deleteProviderAssignment: async function (comments, item) {
      this.$store.commit("uxModule/setShowLoader", true);
      var message = await this.$store.dispatch(
        "plansModule/deleteProviderAssignment",
        { assignmentId: item.assignmentId, comments: comments }
      );
      this.$store.commit("uxModule/setShowLoader", false);
      if (message) {
        this.$store.commit("uxModule/setSnackbarMsg", message);
        this.$store.commit("uxModule/setShowSnackbar", true);
      }
    },
  },
};
</script>
